import DefaultColors from 'tailwindcss/colors';
import { hexToRgb } from '#lib/utils/units.js';
import { isString } from '#lib/utils/string.js';

export const makeTailwindPalette = (name) => {
    return DefaultColors[name];
}

// function to convert preview palettes from hex to rgb
export function convertStyles(hexStyles) {
    if (!hexStyles) return;
    const rgbStyles = structuredClone(hexStyles);
    Object.entries(rgbStyles).forEach(([color, palette]) => {
        if (isString(palette) || !palette) return;
        Object.entries(palette).forEach(([grad, value]) => {
            if (value.charAt(0) === '#') {
                palette[grad] = `${hexToRgb(value).join(' ')}`;
            }
        });
    });
    return rgbStyles;
}

export function displayValuePalette(option) {

    return (
        <div className="flex items-center gap-2">
            <span
                aria-hidden
                className={`block h-5 w-5 flex-shrink-0 rounded-sm shadow-sm shadow-white`}
                style={{ backgroundColor: DefaultColors[option]?.[600] }}
            />
            {option}
        </div>
    )
}